import {
  CatalogProductAddAction,
  CatalogProductAddItem,
  CatalogProductTypeEnum,
  CatalogId,
  CatalogTypeEnum,
  CatalogAppSettings,
  ClientInfo,
  CatalogActionResult,
  CatalogActionError,
  CatalogProductAutocompleteQuery,
  CatalogProductSearchSettings,
  CatalogProductSearchTypeEnum,
  FilterSettings,
  TreeTypeEnum,
  PagerSettings,
  AutocompleteSearchResult,
  ConfigurationOptionQuery,
  ConfigurationOptionSearchResult,
  ConfigurationOptionGroup,
  ConfigurationOptionItem,
  CatalogProductCopyAction,
  CatalogProductCountQuery,
  CountSearchResult,
  CatalogProductDeleteAction,
  CatalogProductDeleteItem,
  CatalogProductFiltersQuery,
  CatalogProductFilterSearchSettings,
  FilterValueSearchResult,
  FilterValueItem,
  FilterValue,
  CatalogProductSearchQuery,
  CatalogProductSearchDataTypeEnum,
  CatalogProductSortSettings,
  CatalogProductSortFieldEnum,
  SortDirectionEnum,
  CatalogProductSearchResult,
  ClassificationsSearchResult,
  ClassificationAdditionalInfo,
  ClassificationAdditionalInfoTypeEnum,
  ClassificationItem,
  CatalogProductsSearchResult,
  CatalogProductItem,
  ProductItemClassifications,
  CatalogDetail,
  CatalogProductQuantityItem,
  CatalogProductUserField,
  FilterSearchResult,
  FilterItem,
  BreadcrumbsSearchResult,
  BreadcrumbItem,
  CatalogProductUpdateAction,
  CatalogProductUpdateItem,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class CatalogsProductsService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Add products to catalog
   */
  static add(
    params: {
      /** requestBody */
      body?: CatalogProductAddAction;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CatalogActionResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Catalogs/Products/Add';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns autocomplete product matches
   */
  static autocomplete(
    params: {
      /** requestBody */
      body?: CatalogProductAutocompleteQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AutocompleteSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Catalogs/Products/Autocomplete';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns configuration option for catalog product
   */
  static configurationOption(
    params: {
      /** requestBody */
      body?: ConfigurationOptionQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConfigurationOptionSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Catalogs/Products/ConfigurationOption';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Copy product to catalog
   */
  static copy(
    params: {
      /** requestBody */
      body?: CatalogProductCopyAction;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CatalogActionResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Catalogs/Products/Copy';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns count of product matches
   */
  static count(
    params: {
      /** requestBody */
      body?: CatalogProductCountQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Catalogs/Products/Count';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete products from catalog
   */
  static delete(
    params: {
      /** requestBody */
      body?: CatalogProductDeleteAction;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CatalogActionResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Catalogs/Products/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns product filters
   */
  static filters(
    params: {
      /** requestBody */
      body?: CatalogProductFiltersQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FilterValueSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Catalogs/Products/Filters';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Search products
   */
  static search(
    params: {
      /** requestBody */
      body?: CatalogProductSearchQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CatalogProductSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Catalogs/Products/Search';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Update product in catalog
   */
  static update(
    params: {
      /** requestBody */
      body?: CatalogProductUpdateAction;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CatalogActionResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Catalogs/Products/Update';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
